import React, { useState } from 'react';
import { Dial, DialAction, ErrorTypeStyles } from './Styled'
import { errorHooks } from '.';
import { Edit, KeyboardArrowLeft, KeyboardArrowRight, KeyboardArrowUp } from '@mui/icons-material';
import { useTheme } from 'styles';
import { assign } from 'lodash'

const ErrorTypes = () => {
    const [openDial, setOpenDial] = useState(false)

    const { Layout } = useTheme()

    const errorTypeList = errorHooks.useErrorTypeList()
    const Icon = openDial ? KeyboardArrowRight : KeyboardArrowLeft

    return (
        <ErrorTypeStyles>
            <Dial
                ariaLabel="SpeedDial basic example"
                sx={{ position: 'absolute', bottom: 0 }}
                icon={
                    <div className='error-list-button' onClick={() => setOpenDial(!openDial)} style={assign(Layout.rowCenter, Layout.scGap)}>
                        מקראה השגיאות
                        <Icon color='thirdly2' openIcon={<Edit />} />
                    </div>
                }
                open={openDial}
                direction='right'
            >
                {errorTypeList.map((error, index) => (
                    <DialAction
                        sx={{ pointerEvents: "none" }}
                        aria-label='dsdsa'
                        key={index}
                        borderColor={error.borderColor}
                        borderStyle={error.borderStyle}
                        opacity={error.opacity}
                        icon={error.label}
                    />
                ))}
            </Dial>
        </ErrorTypeStyles>
    );
}

export default ErrorTypes
